import type { DraftMode } from "./useChangeOrderDraft";

export interface TypeSwitchProps {
  value: DraftMode;
  onChange: (mode: DraftMode) => void;
  disabled?: boolean;
}

const OPTIONS: { mode: DraftMode; label: string }[] = [
  { mode: "scope", label: "Change scope in ScopeStack" },
  { mode: "tracked", label: "Tracked in another system" },
];

// A two-option segmented control; radios underneath for keyboard and screen
// readers.
const TypeSwitch = ({ value, onChange, disabled = false }: TypeSwitchProps) => (
  <div className="changeOrderTypeSwitch mb-3" role="radiogroup" aria-label="Change request type">
    {OPTIONS.map(({ mode, label }) => (
      <label
        key={mode}
        className={`changeOrderTypeOption${value === mode ? " selected" : ""}`}
      >
        <input
          type="radio"
          name="change-order-type"
          value={mode}
          checked={value === mode}
          disabled={disabled}
          onChange={() => onChange(mode)}
        />
        <span>{label}</span>
      </label>
    ))}
  </div>
);

export default TypeSwitch;
